import { ICategorys, IGameCell, IGameData } from "@/common/interface";
import Link from "@/components/common/Link";
import MySwiper from "@/components/common/MySwiper";
import { IGameState } from "@/store/game";
import React, { useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
import { SwiperOptions } from "swiper";
import Img from "@/components/common/Img";
import { useInViewport } from "ahooks";
import { sendClkLog } from "@/common/selfMonitor";
import { comMonitor } from "@/utils/com";

import "./index.scss";
interface IProps {
  banner: IGameData["banner"];
  top: IGameCell;
}

const option: SwiperOptions = {
  effect: "fade",
};

const BannerItem = ({ data = {} as IGameCell }) => {
  // const [startTime, setStartTime] = useState(0);
  // const onMouseDown = (e: React.MouseEvent) => {
  //   e.stopPropagation();
  //   e.preventDefault();
  //   setStartTime(Date.now());
  // };

  // const onMouseUp = (e: React.MouseEvent) => {
  //   if (Array.isArray(data.clktk) && data.clktk.length) {
  //     data.clktk.forEach(url => {
  //       const realUrl = replaceUrlTemplate(url, e, startTime, Date.now());
  //       comMonitor(realUrl);
  //     });
  //   }
  // };
  const categoryText =
    data.category && data.category.length > 0
      ? `${ICategorys[data.category]}`
      : `${ICategorys["1"]}`;
  return (
    <div className="swiper-slide">
      <Link
        className="banner__item"
        softId={data.soft_id}
        openType={data.open_type}
        href={data.href}
        exec={data.exec}
        dataText={categoryText}
        name={data.name}
        position="gamebanner"
        comAds={data.clktk}
        category={data.category}
      >
        <Img className="banner__img" src={data.slider_pic_href} />
        <div className="banner__content">
          <h3 className="banner__name">{data.name}</h3>
          <p className="banner__desc">{data.pic_desc}</p>
        </div>
      </Link>
    </div>
  );
};

const Banner = ({ banner, top }: IProps) => {
  const nodeRef = useRef<HTMLDivElement>(null);
  const [lock, setLock] = useState(false);
  const [inViewport, ratio] = useInViewport(nodeRef, {
    threshold: [0.1, 0.5, 1],
  });
  // // const { soft_id, name } = items.data[index];
  // console.log("banner is", banner);

  useEffect(() => {
    if (inViewport && !lock && ratio && ratio >= 0.1 && banner[0].soft_id) {
      const monitorIds = banner
        .reduce<string>((prev, current) => {
          return (
            prev +
            "|" +
            `${current.soft_id}$${current.name}$${
              current.category && current.category.length
                ? ICategorys[current.category]
                : ICategorys[1]
            }`
          );
        }, "")
        .slice(1);

      const params = {
        cid: `gamebanner`, //事件名称组名
        // c : "下载", //事件名称
        // from: (category && category.length) ? ICategorys[category] : '',
        title: monitorIds,
      };
      sendClkLog(params, "track");
      setLock(true);

      const urlItems = banner.filter((item) => {
        return item.imptk;
      });
      urlItems.forEach((item) => {
        item.imptk.forEach((img: string) => {
          comMonitor(img);
        });
      });
    }
  }, [inViewport, banner, lock, ratio]);

  const list = banner.map((item) => (
    <BannerItem key={item.soft_id} data={item} />
  ));
  return (
    <div ref={nodeRef} className="banner clearfix" data-bk="banner">
      <MySwiper id="bannerSwiper" className="banner__swiper" option={option}>
        {list}
      </MySwiper>
      <Link
        className="banner__right"
        softId={top.soft_id}
        openType={top.open_type}
        href={top.href}
        exec={top.exec}
        dataText="右侧广告"
      >
        <Img src={top.topright_pic_href} />
      </Link>
    </div>
  );
};

const mapStateToProps = ({ gameData: { banner, top } }: IGameState) => ({
  banner,
  top: top[0],
});
export default connect(mapStateToProps)(Banner);
